import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Typography } from '@mui/material';
/** Split on `**…**`, returning the spans between as bold. */
function inline(text, keyPrefix) {
    // Non-greedy so adjacent bold runs don't merge into one giant span.
    return text.split(/(\*\*.+?\*\*)/g).filter(Boolean).map((part, i) => {
        const bold = part.startsWith('**') && part.endsWith('**') && part.length > 4;
        return bold ? (_jsx(Box, { component: "span", sx: { fontWeight: 600, color: '#101828' }, children: part.slice(2, -2) }, `${keyPrefix}-${i}`)) : (_jsx(React.Fragment, { children: part }, `${keyPrefix}-${i}`));
    });
}
const BULLET = /^\s*[-*•]\s+/;
const AiRichText = ({ text }) => {
    const lines = (text || '').split('\n');
    // Group consecutive bullet lines so a run renders as one list rather than a
    // stack of separate ones with paragraph spacing between them.
    const blocks = [];
    for (const line of lines) {
        if (!line.trim())
            continue;
        const isBullet = BULLET.test(line);
        const last = blocks[blocks.length - 1];
        if (isBullet && last?.type === 'ul')
            last.lines.push(line.replace(BULLET, ''));
        else if (isBullet)
            blocks.push({ type: 'ul', lines: [line.replace(BULLET, '')] });
        else if (last?.type === 'p')
            last.lines.push(line);
        else
            blocks.push({ type: 'p', lines: [line] });
    }
    return (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 1 }, children: blocks.map((block, bi) => block.type === 'p' ? (_jsx(Typography, { sx: { fontSize: '13.5px', color: '#101828', lineHeight: '21px', wordBreak: 'break-word' }, children: inline(block.lines.join(' '), `p${bi}`) }, bi)) : (_jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: 0.75 }, children: block.lines.map((line, li) => (_jsxs(Box, { sx: { display: 'flex', gap: 1, alignItems: 'flex-start' }, children: [_jsx(Box, { sx: {
                            width: 5,
                            height: 5,
                            borderRadius: '50%',
                            bgcolor: '#6172F3',
                            flexShrink: 0,
                            mt: '7px',
                        } }), _jsx(Typography, { sx: { fontSize: '13.5px', color: '#475467', lineHeight: '21px', wordBreak: 'break-word' }, children: inline(line, `b${bi}-${li}`) })] }, li))) }, bi))) }));
};
export default AiRichText;
